'use client'

import * as React from 'react'
import { SlidersHorizontal } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useSearchStore } from '@/lib/store'
import { FilterModal } from './filter-modal'
import { useI18n } from '@/lib/i18n'

interface FiltersButtonProps {
  className?: string
  onApply?: () => void
  variant?: 'default' | 'compact'
}

export function FiltersButton({ className, onApply, variant = 'default' }: FiltersButtonProps) {
  const { t } = useI18n()
  const { activeTags, filters, selectedCity, selectedDistricts } = useSearchStore()
  const [modalOpen, setModalOpen] = React.useState(false)

  // Count active filters
  const locationFilterCount =
    (filters.type && filters.type !== 'apartment' ? 1 : 0) +
    (filters.transaction_type && filters.transaction_type !== 'rent' ? 1 : 0) +
    (selectedCity && selectedCity !== 'Praha' ? 1 : 0) +
    (selectedDistricts.length > 0 ? 1 : 0)

  const numericFilterCount =
    (filters.rooms_min ? 1 : 0) + (filters.rooms_max ? 1 : 0) +
    (filters.area_min ? 1 : 0) + (filters.area_max ? 1 : 0) +
    (filters.price_min ? 1 : 0) + (filters.price_max ? 1 : 0)

  // Price mode counts as an active filter, matching the modal's activeCount.
  const priceModeCount = filters.use_total_price === false ? 1 : 0

  const totalActiveCount = activeTags.length + numericFilterCount + locationFilterCount + priceModeCount

  return (
    <>
      <button
        type="button"
        onClick={() => setModalOpen(true)}
        className={cn(
          'flex items-center transition-all flex-shrink-0',
          variant === 'default'
            ? 'px-3.5 py-2 gap-1.5 rounded-full text-[13px] font-semibold border border-outline bg-surface text-foreground active:scale-[0.97]'
            : 'h-10 px-2.5 sm:px-3 gap-1 sm:gap-1.5 rounded-full text-sm font-medium',
          variant === 'compact'
            && 'bg-primary/10 text-primary hover:bg-primary/20 focus:outline-none focus:ring-2 focus:ring-primary/30',
          className
        )}
      >
        <SlidersHorizontal className={cn('h-4 w-4', variant === 'default' && 'text-ink-secondary')} />
        <span className="hidden sm:inline">{t('search.filters', 'Filters')}</span>
        {totalActiveCount > 0 && (
          variant === 'default' ? (
            <span className="font-mono inline-flex h-[17px] min-w-[17px] items-center justify-center rounded-full bg-primary px-1 text-[10.5px] font-bold text-white">
              {totalActiveCount}
            </span>
          ) : (
            <span className="px-1.5 py-0.5 text-xs bg-primary text-primary-foreground rounded-full min-w-[1.25rem] text-center">
              {totalActiveCount}
            </span>
          )
        )}
      </button>

      <FilterModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        onApply={onApply}
      />
    </>
  )
}

